import { Loader } from "@googlemaps/js-api-loader";

function initSuburbSearch() {
  const searchInput = document.getElementById("suburbSearch");
  const suggestionsDiv = document.getElementById("suggestions");
  if (!searchInput || !suggestionsDiv) return;

  async function runSearch() {
    // Import the Places library using the new importLibrary method.
    const { AutocompleteService, PlacesService } = await google.maps.importLibrary("places");
    const autocompleteService = new AutocompleteService();
    // PlacesService still needs a DOM element; we'll use a dummy one.
    const placesService = new PlacesService(document.createElement("div"));

    let debounceTimeout = null;
    searchInput.addEventListener("keyup", function () {
      const query = searchInput.value.trim();
      if (query.length < 3) {
        suggestionsDiv.style.display = "none";
        return;
      }
      if (debounceTimeout) clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        autocompleteService.getPlacePredictions({
          input: query,
          componentRestrictions: { country: "au" },
          types: ["(regions)"]
        }, function (predictions, status) {
          // Use the new PlacesServiceStatus property
          if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            suggestionsDiv.style.display = "none";
            return;
          }
          suggestionsDiv.innerHTML = "";
          predictions.forEach(prediction => {
            const a = document.createElement("a");
            a.href = "#";
            a.className = "list-group-item list-group-item-action";
            a.textContent = prediction.description; // fallback text
            a.addEventListener("click", function (e) {
              e.preventDefault();
              placesService.getDetails({ placeId: prediction.place_id }, function (place, status) {
                if (status === google.maps.places.PlacesServiceStatus.OK && place && place.address_components) {
                  let suburb = "";
                  let state = "";
                  let postcode = "";
                  place.address_components.forEach(component => {
                    if (component.types.includes("locality")) {
                      suburb = component.long_name;
                    }
                    if (component.types.includes("administrative_area_level_1")) {
                      state = component.short_name;
                    }
                    if (component.types.includes("postal_code")) {
                      postcode = component.long_name;
                    }
                  });
                  // Format: "Suburb State Postcode"
                  const formatted = [suburb, state, postcode].filter(Boolean).join(", ");
                  searchInput.value = formatted || prediction.description;
                } else {
                  searchInput.value = prediction.description;
                }
              });
              suggestionsDiv.style.display = "none";
            });
            suggestionsDiv.appendChild(a);
          });
          suggestionsDiv.style.display = "block";
        });
      }, 300);
    });

    document.addEventListener("click", function (e) {
      // If the click is outside the search container, hide suggestions
      if (!document.querySelector(".position-relative").contains(e.target)) {
        suggestionsDiv.style.display = "none";
      }
    });
  }

  // Check if Google Maps API is already loaded.
  if (typeof google !== "undefined" && google.maps) {
    runSearch();
  } else {
    const loader = new Loader({
      apiKey: "AIzaSyA7OpqsOyv1YChC_TxY-oKCvOTBvscJrMw",
      libraries: ["places"],
      version: "weekly"
    });
    loader.load().then(runSearch).catch(err => {
      console.error("Error loading Google Maps API:", err);
    });
  }
}

document.addEventListener("DOMContentLoaded", initSuburbSearch);


export { initSuburbSearch };
